import { Divider, Typography } from "@mui/material";
import RandomQueueItem from "./RandomQueueItem";
import { useSelector } from "react-redux";
import { getRandomModeActive } from "../../reducers/randomMode";

const CurrentAlbumDisplayer = ({currentAlbum, queuePointer}) => {
    const randomModeActive = useSelector(getRandomModeActive);

    return (
        <>
        {
            currentAlbum &&
            <div className="d-flex flex-column jc-center ai-center gap-0_5 full-width">
                <div className="full-width d-flex flex-column gap-0_5">
                    <Typography variant="subtitle1">{ randomModeActive ? "Playing album" : "Paused album" }</Typography>
                    <Divider />
                </div>
                <div></div>
                {
                    <RandomQueueItem 
                        key={queuePointer} 
                        album={currentAlbum} 
                        queueIndex={queuePointer - 1} 
                        isCurrentAlbum={true} 
                        canDeleteAlbum={true}
                    />
                }
            </div>
        }
        </>
    )
};

export default CurrentAlbumDisplayer;